export enum IsActive {
    All = -1,
    Active = 1,
    InActive = 0,
}
